import React from 'react';
import { useLang } from '../context/LangContext';
import LegalPage from '../components/layout/LegalPage';

export default function TermsPage() {
  const { t } = useLang();
  return (
    <LegalPage
      title={t.termsPage.title}
      lastUpdated={t.termsPage.lastUpdated}
      sections={t.termsPage.sections}
      metaTitle={t.meta.termsTitle}
    />
  );
}
